import { render } from "./TipoActivo.vue?vue&type=template&id=8512bb24"
import script from "./TipoActivo.vue?vue&type=script&lang=js"
export * from "./TipoActivo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__